package fr.labodoc.healthProfessional.webApp.pages.dashboard.components

import kotlinx.coroutines.flow.StateFlow

abstract class MedicineListViewModel {
  data class Medicine(
    val index: Int,
    val id: String,
    val laboratory: Laboratory?,
    val name: String,
    val normalizedName: String,
    val logoUrl: String,
    val atcClassificationCode: String,
    val dci: String,
    val normalizedDci: String,
    val atcClassificationCategory: AtcClassification,
    val hasRecentMarketingDocument: Boolean,
    val displayed: Boolean = true
  ) {
    data class Laboratory(
      val name: String
    )

    data class AtcClassification(
      val code: String,
      val name: String
    )
  }

  sealed class MedicineListState {
    data object Loading : MedicineListState()

    data object Error : MedicineListState()

    data class Loaded(
      val medicines: List<Medicine>
    ) : MedicineListState()
  }

  abstract val medicineListState: StateFlow<MedicineListState>

  data class Thematic(
    val id: String,
    val name: String,
    val atcClassificationCodes: Set<String>,
    val numberOfMedicines: Int
  )

  abstract val specialityThematics: StateFlow<List<Thematic>>
  abstract val interspecialityThematics: StateFlow<List<Thematic>>

  data class AtcClassification(
    val code: String,
    val name: String,
    val numberOfMedicines: Int,
    val parentCode: String?
  )

  abstract val atcClassifications: StateFlow<List<AtcClassification>>

  data class SearchBarResult(
    val text: String,
    val isLaboratoryMedicine: Boolean
  )

  abstract val searchBarResults: StateFlow<Set<SearchBarResult>>

  sealed class Filter {
    data class Search(
      val input: String
    ) : Filter()

    data class Thematic(
      val id: String,
      val name: String,
      val atcClassificationCodes: Set<String>,
      val numberOfMedicines: Int
    ) : Filter()

    data class AtcClassification(
      val code: String,
      val name: String,
      val numberOfMedicines: Int
    ) : Filter()

    data object RecentMarketingDocuments : Filter()
  }

  abstract val filter: StateFlow<Filter?>
  abstract val medicinesFilteredCount: StateFlow<Int?>

  abstract val alphabeticalSort: StateFlow<Boolean>

  abstract fun refresh()

  abstract fun resetFilter()

  abstract fun updateSearchBarInput(searchBarInput: String?)

  abstract fun updateAtcClassification(code: String)

  abstract fun updateThematic(thematicId: String?)

  abstract fun updateAlphabeticalSort(alphabeticalSort: Boolean)
}
